<template>
  <d-modal
    class="crm-new-popup order-popup"
    v-if="showCopyModal"
    style="background-color: rgba(0,0,0,0.6)!important;"
    @close="closeModal">
    <d-modal-header :close="true">
      <d-modal-title>
        <h3 class="page-title">
          Kopiuj zamówienie klienta:
          <p class="text-success font-weight-light ml-2 mt-2">{{customer.name ? customer.name : ''}}</p>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer
        ref="orders-form"
        tag="form">
        <d-row>
          <d-col md="4">
            <div class="form-group calendar-inline">
              <label for="delivery_date">
                Data dostawy:
              </label>
              <validation-provider
                rules="required"
                name="delivery_date"
                v-slot="{ errors }">
                <date-picker
                  v-model="data.delivery_date"
                  :inline="true"
                  valueType="format"
                  class="mr-2 w-100"/>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
          <d-col md="8">
            <div class="form-group">
              <label for="customer_id">
                Klient:
              </label>
              <validation-provider
                rules="required"
                name="customer_id"
                v-slot="{ errors }">
                <filter-autocomplete
                  v-model="data.customer_id"
                  ref="customer_selector"
                  style="width: 100%"
                  @input="updateCustomer($event)"
                  :endpoint-items="'/customers/items'"
                  :data-id="filters.customer_id"
                  :reduce="obj => obj.id"
                  :endpoint-item="'/customers/item/'"
                  :placeholder="customer.name ? customer.name : 'Znajdź klienta...'"/>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
            <div class="form-group">
              <label for="shop_id">
                Adres dostawy:
              </label>
              <validation-provider
                rules="required"
                name="shop_id"
                v-slot="{ errors }">
                <filter-suggestion
                  :key="data.customer_id"
                  v-model="data.shop_id"
                  style="width: 100%"
                  @input="updateShop($event)"
                  :endpoint-items="'/customers/shops/items'"
                  :data-id="filters.shop_id"
                  :reduce="obj => obj.id"
                  :endpoint-item="'/customers/shops/item/'"
                  :placeholder="'Znajdź adres...'"
                  :customer-id="data.customer_id"/>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
        </d-row>
      </validation-observer>
      <div class="standard-buttons-form">
        <d-button
          class="mt-0 mb-4"
          :class="{isLoading: form_submitting}"
          :disabled="(!data.delivery_date || !data.customer_id || !data.shop_id)"
          :theme="'success'"
          @click.prevent="submitForm">
          Zapisz zamówienie
        </d-button>
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from '@/utils/FormUtils';
import FilterAutocomplete from '@/components/others/filterAutocomplete';
import FilterSuggestion from '@/components/others/filterSuggestion';
import OrdersFormPaymentConfirm from './OrdersFormPaymentConfirm';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'order-copy-modal',
  components: {
    DatePicker,
    OrdersFormPaymentConfirm,
    FilterSuggestion,
    FilterAutocomplete,
  },
  data () {
    return {
      data: {
        id: 0,
        customer_id: 0,
        delivery_date: null,
        shop_id: 0,
      },
      form_submitting: false,
      customer: {},
      loaded: false,
      filters: {
        customer_id: 0,
        shop_id: 0,
      },
    };
  },
  props: {
    showCopyModal: {
      type: Boolean,
      required: true
    },
    orderCustomer: {
      type: [Object, Array, String, Number],
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    orderId: {
      type: [Object, Array, String, Number],
      required: true
    },
    customerId: {
      type: [Object, Array, String, Number],
      required: true
    },
  },
  mounted () {
    this.loaded = true;
    if (this.customerId) {
      this.loadCustomer(this.customerId);
    }
    if (this.orderId) {
      this.loadItemData(this.orderId);
    }
  },
  watch: {
    'customerId': function (id) {
      if (id) {
        this.loadCustomer(id);
      }
    },
    'showCopyModal': function (value) {
      if (value === true) {
        this.loadItemData();
        return;
      }

      this.clearDataAll();
    },
    'orderCustomer': function (customer) {
      if (customer.id) {
        this.customer = customer;
      }
    }
  },
  methods: {
    clearDataAll () {
      this.data.id = 0;
      this.data.customer_id = 0;
      this.data.delivery_date = null;
      this.data.shop_id = 0;
      this.closeModal();
      this.loaded = false;
    },
    loadCustomer (id) {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/customers/item/' + id,
        outputKey: 'customer'
      });
    },
    updateCustomer () {
      this.data.shop_id = '';
      this.$forceUpdate();
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/orders/item/',
        id: this.orderId,
        instanceFields: ['id', 'customer_id', 'shop_id', 'delivery_date'],
        successAction: () => {
          if (this.orderId === this.data.id && this.showCopyModal) {
            this.data.shop_id = '';
            this.loaded = true;
            this.$forceUpdate();
          }
        }
      });
    },
    submitForm () {
      let formDataToSend = {
        customer_id: this.data.customer_id,
        shop_id: this.data.shop_id,
        delivery_date: this.data.delivery_date,
        duplicated_from: this.data.id
      };
      let endpointUrl = '/orders/duplicate ';

      this.submitted_form = true;
      this.form_submitting = true;
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano zamówienie',
        successText: 'Wybrane zamówienie zostało zapisane',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja zamówienia nie powiodła się. Spróbuj ponownie.',
        successAction: (response) => {
          this.$router.push('/zamowienia/edycja/' + response.id);
          this.submitted_form = false;
          this.form_submitting = false;
        },
        failureAction: () => {
          this.submitted_form = false;
          this.form_submitting = false;
        }
      });
    },
    updateShop (id) {
      this.data.shop_id = id;
      this.$forceUpdate();
    }
  },
  beforeDestroy () {
    this.clearDataAll();
  }
};
</script>
<style lang="scss">

  .calendar-inline .mx-calendar{
    margin: 0 auto;
  }

  .modal-title {
    width: 100%;
  }
  .custom-input-new, .custom-input-new-disabled {
     width: 100%;
     height: auto;
     padding: 0.4375rem 0.75rem;
     font-size: 0.8125rem;
     line-height: 1.5;
     font-weight: 300;
     will-change: border-color, box-shadow;
     border-radius: 0.25rem;
     outline: none;
   }
  .custom-input-new-disabled {
    cursor: no-drop;
   }
  .custom-input-new-invalid {
     width: 100%;
     height: auto;
     padding: 0.4375rem 0.75rem;
     font-size: 0.8125rem;
     line-height: 1.5;
     border: 1px solid var(--theme-color);
     font-weight: 300;
     will-change: border-color, box-shadow;
     border-radius: 0.25rem;
     outline: none;
     box-shadow: 0 5px 11.5px rgba(196, 24, 60, 0.1);
   }
  .swal2-modal {
    border: 1px solid var(--form-border-color) !important;
    box-shadow: 0 0 17px 6px rgba(0,0,0,0.1);
  }
</style>
